export const onlyUnique = (value: any, index: number, self: any) => self.indexOf(value) === index;

export const onlyUniqueNonBlank = (value: any, index: number, self: any) => !!value && onlyUnique(value, index, self);

export const SumNumber = (array: number[]): number => array.reduce((a, b) => a + b, 0);

// Normalises any date/time to a timestamp representing midnight on its UTC calendar day - used to
// bucket items into day-based groups regardless of the time-of-day component.
export const getDateGroupKey = (input: Date | string): number => {
  const dt = new Date(input);
  return new Date(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate(), 0, 0, 0, 0).getTime();
};

export const getDateGroupTitle = (input: Date | string): string => new Date(getDateGroupKey(input)).toDateString();

export interface DateGroup<T> {
  title: string;
  items: T[];
}

// Groups items by calendar day (via getDateGroupKey/getDateGroupTitle), preserving the order in
// which each day's group was first encountered.
export const groupByDate = <T>(items: T[], getDate: (item: T) => Date | string | null | undefined): DateGroup<T>[] => {
  const groups = new Map<number, DateGroup<T>>();

  items.forEach((item) => {
    const value = getDate(item);
    const date = value ? new Date(value) : null;
    const key = date && !isNaN(date.getTime()) ? getDateGroupKey(date) : NaN;
    const title = isNaN(key) ? 'No Date' : getDateGroupTitle(date as Date);

    if (!groups.has(key)) {
      groups.set(key, { title, items: [] });
    }
    groups.get(key)!.items.push(item);
  });

  return Array.from(groups.values());
};
